import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
/* import makeRequest from '../../../../utils/makeRequest'; */
import classNames from 'classnames';
import s from './Morebtn.scss';

class Morebtn extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const {
      moreText,
      moreLink,
      isWhiteText,
      absoluteMoreText,
      linkData = {},
      doNotChangeURL,
      btnClass,
      useLightBGMoreBtn,
      isNoLink,
      onClick,
      ga4Type,
      ga4Category,
      gaLabel,
      isMobile,
      forceTargetBlank,
      userGrxId,
    } = this.props;
    const buttonClass = classNames({
      [s.morebtn]: true,
      [s.text_white]: isWhiteText,
      [s.lighBgBtn]: useLightBGMoreBtn,
      [s.isNoLink]: isNoLink,
    });
    if (!(moreLink || isNoLink)) return null;
    return (
      <Link
        to={moreLink}
        target="_blank"
        className={`${buttonClass} ${btnClass}`}
        data={linkData}
        doNotChangeURL={doNotChangeURL}
        isNoLink={isNoLink}
        onClick={onClick}
        forceTargetBlank={forceTargetBlank}
        // data-newga={`${linkData.gaCategory}#${linkData.gaAction}#${
        //   linkData.gaLabel
        // }`}
        isMobile={isMobile}
        ga4Data={
          ga4Type && [
            {
              event: 'user_click',
              type: `${ga4Type}`,
              category: ga4Category || 'more_stories_cta_click',
              label: `${gaLabel ||
                absoluteMoreText ||
                `more ${moreText} stories`}`,
              ...(userGrxId && { user_grx_id: userGrxId }),
            },
          ]
        }
      >
        {absoluteMoreText || `more ${moreText} stories`}
        <i />
      </Link>
    );
  }
}
Morebtn.propTypes = {
  moreText: PropTypes.string,
  moreLink: PropTypes.string,
  isWhiteText: PropTypes.bool,
  absoluteMoreText: PropTypes.string,
  linkData: PropTypes.shape({}),
  doNotChangeURL: PropTypes.bool,
  btnClass: PropTypes.string,
  useLightBGMoreBtn: PropTypes.bool,
  isNoLink: PropTypes.bool,
  onClick: PropTypes.func,
  ga4Type: PropTypes.string,
  isMobile: PropTypes.bool,
};
Morebtn.defaultProps = {
  moreText: '',
  moreLink: '',
  isWhiteText: false,
  absoluteMoreText: '',
  linkData: undefined,
  doNotChangeURL: false,
  btnClass: '',
  useLightBGMoreBtn: false,
  isNoLink: false,
  onClick: null,
  ga4Type: '',
  isMobile: false,
};

export default Morebtn;
